<template>
  <VUEModal v-if="PopupUdmX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="ObjGrafico.AxisX.UdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>
      </div> 
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjGrafico.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Min">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Max">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Udm">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>
  
  <div style="min-height:500px; min-width:1200px">
    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamentiSovrapposti','TKN_FRM_COMP_GRAF_STOR_GRAF_SPOST_SOVR',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_DIREZIONE_RIFERIMENTO',this.LinguaUtente) + ' (' + OrientamentoAsse + this.GetTraduzioneLabel('UdmGenerali','TKN_GRADI_NORD',this.LinguaUtente) + ')' }}</text>
    </div>
    <div style="width:83%;float:left" ref="DivCanvas">
      <VUEComponenteGraficoSpostamentiSovrapposti :WidthGrafico="GrandezzaCanvas.Width" 
                                                  :HeightGrafico="GrandezzaCanvas.Height"
                                                  :ListaModuli="ListaModuli"
                                                  :ObjDal="ObjDal"
                                                  :ObjAl="ObjAl"
                                                  :TipoGrafico="TipoGrafico"
                                                  :PropsGrafico="ObjGrafico"
                                                  :Repaint="Repaint"
                                                  :GraficiChange="GraficiChange"
                                                  :PressAdatta="PressAdatta"/>
    </div>
      
    <div style="width:17%;float:left; border: solid 1px black;margin-top:24px" ref="DivButtons" >
      <div style="margin-top:5px;">
        <div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
           
            <div style="width:5%; float:left;" :style="{'background-color': ColoriPantone.Marrone}">
              <label style="font-weight: bold; color: white">&nbsp;</label>
            </div>
            <div style="width:60%; float:left;" :style="{'background-color': ColoriPantone.Marrone}">
              <label style="font-weight: bold; color: white">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) }} </label>
            </div>
            <div style="width:35%; float:left;" :style="{'background-color': ColoriPantone.Marrone}">
              <label style="font-weight: bold; color: white">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</label>
            </div>
            <div style="clear:both;height:5px"></div> 

            <div style="overflow:auto; max-height: 450px">
              <template v-for="Modulo in ObjGrafico.ListaModuli" :key="Modulo.Id">
                <div style="float:left;width:5%;">
                  <input style="float:left;height:100%" v-model="Modulo.Visualizzato" @change="Repaint++" type="checkbox" class="form-control"/>
                </div> 
                <div style="float:left;width:60%;">
                  <label style="float:left;font-weight:bold;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) }} {{ Modulo.NomeModulo }}</label>
                </div> 
                <div style="float:left;width:35%;margin-top:2px">
                  <div class="ZMColorPickerDiv" :style="{'background-color' : Modulo.Colore, 'width' : '50px'}" @click="ApriPopupColorPicker(Modulo)">&nbsp;</div>
                </div>
                <div style="clear:both;height:3px"></div> 
              </template>
            </div>
            
            <div style="clear:both;height:1px"></div>
          </div>
          <div style="clear:both"></div>
        </div>
        
        <div style="width: 100%; margin-top: 5px;">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%">
            <button type="button" class="btn btn-info" @click="OnClickUdmX" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%">
            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniY" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float: left; width: 4%">&nbsp;</div>
          <div style="float: left; width: 92%">            
            <button type="button" class="btn btn-info" style="width:100%; margin-bottom: 5px" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
          </div>
        </div>
      </div>   
      <div style="float:left;">&nbsp;</div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import { COLORI_PANTONE, TIPI_UDM_X, SystemInformation } from '@/SystemInformation'
import VUEModal from '@/utils/VUEModal.vue'
import VUEComponenteGraficoSpostamentiSovrapposti from './VUEComponenteGraficoSpostamentiSovrapposti.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            OrientamentoAsse      : SystemInformation.OggettoInfoGraficiStorici.OrientamentoAsse,
            LinguaUtente          : SystemInformation.UserInformation.Lingua,
            TipiUdmX              : TIPI_UDM_X,
            TipoUdmX              : 0,
            GrandezzaCanvas       : {
                                      Width  : 0,
                                      Height : 0
                                    },
            ObjGrafico            : {
                                      AxisY  : {
                                                  Min : 0,
                                                  Max : 0,
                                                  Udm : 0,
                                                  Modificato : false,
                                               },
                                    },
            Repaint                : 0,
            PressAdatta            : 0,
            PopupUdmX              : false,
            PopupImpostazioniAsseY : false,
            PopupColorPicker       : false,
            ColoreInModifica       : { 
                                        Colore           : '#000000',
                                        ModuloInModifica : null 
                                     },
            ColoreBottoni          : COLORI_PANTONE.Marrone
          }
  },

  props : [
            'ListaModuli', 
            'ObjDal', 
            'ObjAl', 
            'TipoGrafico', 
            'GraficiChange', 
            'ParametriPDF',
            'GetDatiPDF'
          ],

  emits : ['EsportaPDFGrafico'],

  components: { 
                VUEComponenteGraficoSpostamentiSovrapposti,
                VUEModal,
                VUEColorPicker
              },

  methods :
  {
    EsportaComePDF()
    {
      this.$emit('EsportaPDFGrafico', -1)
    },    

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.ObjGrafico.AxisX.Modificato = true
      this.Repaint++
      this.PopupUdmX = false
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      for (let i = 0; i < this.CurrentListaModuli.length; i++)
      {
        this.CurrentListaModuli[i].MaxAdattamentoAsseYSpost = this.ObjGrafico.AxisY.Max
        this.CurrentListaModuli[i].MinAdattamentoAsseYSpost = this.ObjGrafico.AxisY.Min
        this.CurrentListaModuli[i].UdmYSpost                = this.ObjGrafico.AxisY.Udm
      }

      this.ObjGrafico.AxisY.Modificato = true 
      this.Repaint++
      this.PopupImpostazioniAsseY = false 
    },

    AnnullaPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = false
    },

    GetGraficiPDF()
    {
      let ModuliConsiderati = []
      for (let i = 0; i < this.ListaModuli.length; i++)
      {
        let SingleElemento = TZGenericFunct.GetCopyOfObject(this.ListaModuli[i])
        SingleElemento.Dati = []
        ModuliConsiderati.push(SingleElemento)
      }

      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []
      
      ModuliConsiderati.DettagliGrafico = TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico)
      ModuliConsiderati.Legenda = this.ObjGrafico.ListaModuli.filter((element) =>{ return element.Visualizzato })

      this.ObjPDF.PDFModulo.push(ModuliConsiderati)
      this.ObjPDF.PDFObjDatiGrafici.push(TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico))
    },

    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = 540
    },

    ApriPopupColorPicker(Modulo)
    {
      this.ColoreInModifica.Colore = Modulo.Colore
      this.ColoreInModifica.ModuloInModifica = Modulo
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ColoreInModifica.ModuloInModifica.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
      this.Repaint++
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    GetUnitaDiMisuraAsseY()
    {
      return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
    },

    CalcoloListaModuli()
    {
      this.ObjGrafico.ListaModuli = []
      for(let i = 0; i < this.ListaModuli.length; i++)
      {
        if(this.ListaModuli[i].MinAdattamentoAsseYSpost < this.ObjGrafico.AxisY.Min)
          this.ObjGrafico.AxisY.Min = this.ListaModuli[i].MinAdattamentoAsseYSpost
        if(this.ListaModuli[i].MaxAdattamentoAsseYSpost > this.ObjGrafico.AxisY.Max)
          this.ObjGrafico.AxisY.Max = this.ListaModuli[i].MaxAdattamentoAsseYSpost

        this.ObjGrafico.AxisY.Udm = this.ListaModuli[i].UdmYSpost

        this.ObjGrafico.ListaModuli.push({
                                            NomeModulo   : this.ListaModuli[i].Id,
                                            Visualizzato : true,
                                            Colore       : TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff', COLORI_PANTONE.Arancione ]),
                                        }) 
      }
    }
  },
  
  computed:
  {
    CurrentListaModuli :
    {
      get()
      {
        return this.ListaModuli
      }
    },

    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    }
  },

  watch:
  {
    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    },
  },

  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
  },
  beforeMount()
  {
    this.CalcoloListaModuli()

    let AxisX                         = {}
    AxisX.TipoUdmX                    = TIPI_UDM_X.Giorni
    AxisX.UdmX                        = 1
    AxisX.Modificato                  = false
    this.ObjGrafico.AxisX             = AxisX
  }
}
</script>